// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mTJB","toggleWrap":"styles_toggleWrap__18idL","content":"styles_content__3o8bt","selectAreaCode":"styles_selectAreaCode__1vqdn"};